/**
 * components/StatTile — a single KPI: label, big value, optional sub-line and a thin
 * tone accent bar. Tone drives the accent color only (profit/loss/neutral); the value
 * text stays in primary ink so meaning is never color-alone (dataviz status rule).
 */
import type { ReactNode } from 'react';

export type Tone = 'profit' | 'loss' | 'neutral' | 'warning';

const ACCENT: Record<Tone, string> = {
  profit: 'var(--profit)',
  loss: 'var(--loss)',
  neutral: 'var(--accent)',
  warning: 'var(--warning)',
};

interface StatTileProps {
  readonly label: string;
  readonly value: ReactNode;
  readonly sub?: ReactNode;
  readonly tone?: Tone;
}

export function StatTile({ label, value, sub, tone = 'neutral' }: StatTileProps): JSX.Element {
  return (
    <div className="stat-tile">
      <span className="stat-tile__label">{label}</span>
      <span className="stat-tile__value num">{value}</span>
      {sub && <span className="stat-tile__sub">{sub}</span>}
      <span className="stat-tile__accent" style={{ background: ACCENT[tone] }} />
    </div>
  );
}
